// 'use strict';

function hasClass(el, className) {
  return ' ' + el.className + ' '.indexOf(' ' + className + ' ');
}

function removeClass (el, cl) {
  if (el) {
    var a = [];
    // If SVG
    if (typeof el.className.baseVal !== 'undefined') a = el.className.baseVal.split(' ');
    else a = el.className.split(' ');

    rem(a, cl);

    // If SVG
    if (typeof el.className.baseVal !== 'undefined') el.className.baseVal = a.join(' ');
    else el.className = a.join(' ');
  }
}

function rem (a, x) {
  var i = pos(x, a);
  if (i >= 0) {
    a.splice(i, 1);
  }
  return a;
}

function pos (x, a) {
  return (typeof x == 'function') ? posf(x,a) : Array.prototype.indexOf.call(a,x)
}


// Compare paths for equality
function compareURLs(url1, url2) {
  // Remove trailing slashes in path
  if (url1.length > 1 && url1[url1.length - 1] === '/') url1 = url1.substr(0, url1.length - 1);
  if (url2.length > 1 && url2[url2.length - 1] === '/') url2 = url2.substr(0, url2.length - 1);
  return url1 === url2;
}

function randInt(min, max) {
  return parseInt((Math.random() * (max + 1 - min)) + min);
}

function stringAsCharPattern(str, charPattern) {
  let pattern = '';
  for (let i = 0; i < str.length; i += 1) {
    pattern += charPattern;
  }
  return pattern;
}

module.exports = {
  compareURLs,
  hasClass,
  removeClass,
  randInt,
  stringAsCharPattern
}



// WEBPACK FOOTER //
// ./src/js/helpers.js